module.exports = __webpack_public_path__ + "img/27.ed9545dc.jpg";